import React, {useRef, useState} from 'react'
import Text from '../../components/text/Text'
import WizImage from '../../components/image/WizImage'
import ic_trash from '../../assets/images/icon_trash.png'
import {postUploadImage} from '../../apis/image/postUploadImage'

interface IProps {
    value?: string
    onChange: (image: string) => void
}

// 이미지 content_block 하나당 이미지 1개. URL을 직접 입력하지 않고 업로드 후 응답 URL을 자동 반영한다.
const ImageBlockField: React.FC<IProps> = ({value, onChange}) => {
    const inputRef = useRef<HTMLInputElement>(null)
    const [uploading, setUploading] = useState(false)

    const onChangeImage = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const imageFile = e?.target?.files?.[0]
        if (!imageFile) return

        setUploading(true)
        try {
            const result = await postUploadImage(imageFile)
            if (result?.image_url) onChange(result.image_url)
        } finally {
            setUploading(false)
            if (inputRef.current) inputRef.current.value = ''
        }
    }

    const onClickRemove = (e: React.MouseEvent) => {
        e.stopPropagation()
        onChange('')
    }

    return (
        <div>
            <input type={'file'} accept={'image/*'} onChange={onChangeImage} ref={inputRef} className={'hidden'} />
            <button
                type={'button'}
                onClick={() => inputRef.current?.click()}
                disabled={uploading}
                className={
                    'w-full border border-dashed border-line02 rounded-[8px] px-[16px] py-[20px] flex flex-col items-center justify-center gap-y-[10px] bg-white hover:border-primary cursor-pointer disabled:cursor-default'
                }>
                {value ? (
                    <div className={'relative'}>
                        <WizImage
                            src={`${value}?type=webp&width=1000&quality=100`}
                            className={'max-w-[240px] max-h-[240px] rounded-[8px]'}
                        />
                        <div className={'absolute top-[-12px] right-[-12px]'}>
                            <WizImage
                                onClick={onClickRemove}
                                src={ic_trash}
                                className={'bg-white w-[28px] p-[3px] rounded-full border border-line02 cursor-pointer'}
                            />
                        </div>
                    </div>
                ) : (
                    <Text className={'text-body3 text-font03'}>{uploading ? '업로드 중...' : '+ 이미지 추가'}</Text>
                )}
            </button>
        </div>
    )
}

export default ImageBlockField
